import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTheme } from '../../contexts/ThemeContext';
import Button from '../../components/Button';
import Input from '../../components/Input';
import { supabase } from '../../services/supabaseClient';
import './styles.css';

const EsqueciSenha: React.FC = () => {
  const { darkMode } = useTheme();
  const navigate = useNavigate();
  
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_success, setSuccess] = useState(false);
  const [emailSent, setEmailSent] = useState(false);

  useEffect(() => {
    // do not auto-redirect; show inline message and allow user to go back to login
  }, [emailSent, navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setError('Por favor, insira seu e-mail');
      return;
    }
    
    // Validação simples de e-mail
    if (!/\S+@\S+\.\S+/.test(email)) {
      setError('Por favor, insira um e-mail válido');
      return;
    }
    
    setLoading(true);
    setError('');
    
    try {
      // Verificar se o e-mail existe antes de enviar o link
      const { data: userData, error: userError } = await supabase
        .from('usuarios')
        .select('email')
        .eq('email', email)
        .single();
      
      if (userError || !userData) {
        setError('Nenhuma conta encontrada com este e-mail');
        setLoading(false);
        return;
      }
      
      // Enviar e-mail de redefinição
      const { error: resetError } = await supabase.auth.resetPasswordForEmail(email, {
        redirectTo: `${window.location.origin}/redefinir-senha`,
      });
      
      if (resetError) {
        if (resetError.message.includes('rate limit')) {
          setError('Muitas tentativas. Por favor, tente novamente mais tarde.');
        } else {
          setError('Erro ao enviar e-mail de redefinição. Tente novamente.');
        }
        return;
      }
      
      setEmailSent(true);
      setSuccess(true);
    } catch (err) {
      console.error('Erro ao processar recuperação de senha:', err);
      setError('Ocorreu um erro inesperado. Tente novamente mais tarde.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`body-wrapper auth-wrapper d-flex align-items-stretch ${darkMode ? 'dark-mode' : ''}`}>
      <div className="d-flex flex-grow flex-column-reverse flex-sm-row w-100">
        <div className="auth-bg py-5 py-sm-0 col-sm-6">
          <p className="auth-credits py-5">
            <span className="footer-message">
              {/* heart removed */} <br />
            </span>
            <small className="footer-copyright">
              Copyright © 2025 - trading<br />Todos os direitos reservados.
            </small>
          </p>
        </div>
        
        <div className="auth-panel-wrapper col">
          <div className="auth-panel py-5">
            <img 
              src="/logo-trading.png" 
              className="auth-logo mx-auto" 
              alt="Trading Logo"
            />
            
            <div className="auth-header mt-4">
              <h4 className="auth-title">Recuperar senha</h4>
              <p className="auth-subtitle">Insira o e-mail utilizado na sua conta e enviaremos um link para redefinir sua senha.</p>
            </div>

            <form onSubmit={handleSubmit}>
              {error && <div className="alert alert-danger">{error}</div>}
              {emailSent && (
                <div className="alert alert-success" role="alert">
                  Link de redefinição enviado para o seu e-mail. Verifique a caixa de entrada.
                </div>
              )}
              
              <div className="form-group py-3">
                <Input
                  label="E-mail"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Seu melhor e-mail"
                  autocomplete="username"
                  required
                />
              </div>

              <Button type="submit" variant="auth" fullWidth disabled={loading}>
                {loading ? 'Enviando...' : 'Enviar link de redefinição'}
              </Button>

              <div className="text-center mt-3">
                <Link to="/login" className="text-decoration-none">Voltar para o login</Link>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EsqueciSenha;